var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"com-filed clearfix"},[_c('div',{staticClass:"label"},[(_vm.required)?_c('span',{staticClass:"need"},[_vm._v("*")]):_vm._e(),_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }